import React, { useState, useEffect } from "react";
import LoginFooter from "../components/Footer/LoginFooter";
import { LoginServices } from "../services/LoginServices";
import { VisibilityOff, Visibility } from '@mui/icons-material';
import Notification from "../components/Notifications/Notification";
const LoginPage = () => {
  const [viewPass, setViewPass] = useState(false);
  const [notification, setNotification] = useState(null);
  const [formData, setFormData] = useState({
    login: "",
    password: "",
    rememberPassword: false,
  });

  useEffect(() => {
    const expiredMessage = localStorage.getItem("session_expired_message");
    if (expiredMessage) {
      showNotification(
        "warning",
        "Sessão Expirada",
        expiredMessage
      );
      localStorage.removeItem("session_expired_message");
    }
  }, []);

  const showNotification = (type, title, message) => {
    setNotification({ type, title, message });
    setTimeout(() => {
      setNotification(null);
    }, 4000);
  };

  function handleInputChange(event) {
    const { name, value, type, checked } = event.target;
    const fieldValue = type === "checkbox" ? checked : value;

    setFormData({
      ...formData,
      [name]: fieldValue,
    });
  }

  function handleLoginSubmit(event) {
    event.preventDefault();
    const { login, password } = formData;
    LoginServices.login(login, password).then((success) => {
      if (success) {
        window.location.href = "/research-progress";
      } else {
        showNotification(
          "warning",
          "Usuário ou senha Inválidos",
          "Tente novamente ou contate um administrador!"
        );
      }
    });
  }

  return (
    <>
      <div className="flex flex-col justify-between h-screen">
        <div className="flex uppercase text-4xl m-12 my-6 font-bold">
          <h1>
            ESTUDO <span className="dark-primary">EPIDEMIOLÓGICO </span>
          </h1>
        </div>
        <div className="flex flex-col mx-auto my-auto">
          <form onSubmit={handleLoginSubmit}>
            <label className="pb-6">Email</label>
            <br />
            <input
              type="text"
              name="login"
              value={formData.login}
              onChange={handleInputChange}
              placeholder="administrador@gmail.com"
              className="w-96 py-2 px-2 rounded-sm border-2 border-gray-300 bg-gray-100 mb-4 mt-2"
            />
            <br/>
            <label>Password</label> <br/>
            <div className="relative">
              <input
                type={viewPass ? "text" : "password"}
                name="password"
                value={formData.password}
                onChange={handleInputChange}
                placeholder="*********"
                className="w-96 py-2 pl-2 pr-10 rounded-sm border-2 border-gray-300 bg-gray-100 mb-4 mt-2"
              />
              {viewPass ? (
                <VisibilityOff
                  style={{width: "20px", height: "20px"}}
                  className="absolute right-0 top-0 mt-5 mr-3 cursor-pointer text-xs"
                  onClick={() => setViewPass(!viewPass)}
                />
              ) : (
                <Visibility
                  style={{width: "20px", height: "20px"}}
                  className="absolute right-0 top-0 mt-5 mr-3 cursor-pointer text-xs"
                  onClick={() => setViewPass(!viewPass)}
                />
              )}
            </div>
            <input
              type="checkbox"
              name="rememberPassword"
              checked={formData.rememberPassword}
              onChange={handleInputChange}
            />
            <label> Lembrar minha senha </label>
            <input
              type="submit"
              name="submit"
              value="Entrar"
              className="w-full py-4 bg-dark-primary text-white rounded-xl mt-12 uppercase cursor-pointer hover:bg-dark-primary"
            />
          </form>
        </div>
        {notification && (
          <Notification
            type={notification.type}
            title={notification.title}
            message={notification.message}
          />
        )}
        <LoginFooter />
      </div>
    </>
  );
};

export default LoginPage;
